export const USER_TYPES = {
	STUDENT: "Student",
	CONTRIBUTOR: "Contributor",
	BOTH: "Student;Contributor",
};